import React, { useState, useEffect } from 'react';
import Footer from './Footer';
import { usePresaleListDetailsQuery, useDeleteUserMutation, useActiveRoundlistMutation, useActiveEditPresaleInfoMutation, useCheckEditPresaleInfoMutation } from './store/ReduxApis';
import { Link } from 'react-router-dom';
import DeleteUser from './DeleteUser';
import toast, { Toaster } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import 'react-notifications/lib/notifications.css';
import Web3 from "web3";

function PresaleRoundList() {
    // let web3;
    let accounts = [];

    const web3 = new Web3(process.env.REACT_APP_BSC_CHAIN_TESTNET_RPC_URL);

    let CONTRACT_ADDRESS = process.env.REACT_APP_PRESALE_CONTRACT
    let CONTRACT_ABI = JSON.parse(process.env.REACT_APP_PRESALE_CONTRACT_ABI);
    let stkTokenContract = new web3.eth.Contract(CONTRACT_ABI, CONTRACT_ADDRESS);
    console.log("CONTRACT_ADDRESS----", CONTRACT_ADDRESS)
    const switchToBNBTestnet = async () => {
        try {
            await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: "0x61" }], // BNB Smart Chain Testnet (Chain ID: 97) 0x38// 
            });
            toast.success("Switched to BNB Smart Chain!");
        } catch (switchError) {
            if (switchError.code === 4902) {
                // If network is not added, add it
                await window.ethereum.request({
                    method: "wallet_addEthereumChain",
                    params: [
                        {
                            chainId: "0x61",
                            chainName: "Binance Smart Chain",
                            rpcUrls: [process.env.REACT_APP_BSC_CHAIN_RPC_URL],
                            nativeCurrency: {
                                name: "BNB",
                                symbol: "BNB",
                                decimals: 18,
                            },
                        },
                    ],
                });
                toast.success("BNB Smart Chain  added!");
            } else {
                toast.error("Failed to switch network.");
            }
        }
    };

    const connectWallet = async () => {
        if (typeof window === "undefined" || !window.ethereum) {
            alert("MetaMask not found. Please install MetaMask.");
            return;
        }

        // ✅ Check for multiple wallet providers first
        const detectedWallets = [];

        // Check for common wallet providers
        if (window.ethereum.isExodus) detectedWallets.push('Exodus');
        if (window.ethereum.isCoinbaseWallet || window.ethereum.selectedProvider?.isCoinbaseWallet) detectedWallets.push('Coinbase');
        if (window.ethereum.isRabby) detectedWallets.push('Rabby');
        if (window.ethereum.isTrustWallet) detectedWallets.push('Trust Wallet');
        if (window.ethereum.isMetaMask) detectedWallets.push('MetaMask');

        // Check providers array if available
        if (window.ethereum.providers && Array.isArray(window.ethereum.providers)) {
            window.ethereum.providers.forEach(provider => {
                if (provider.isExodus && !detectedWallets.includes('Exodus')) detectedWallets.push('Exodus');
                if ((provider.isCoinbaseWallet || provider.selectedProvider?.isCoinbaseWallet) && !detectedWallets.includes('Coinbase')) detectedWallets.push('Coinbase');
                if (provider.isRabby && !detectedWallets.includes('Rabby')) detectedWallets.push('Rabby');
                if (provider.isTrustWallet && !detectedWallets.includes('Trust Wallet')) detectedWallets.push('Trust Wallet');
                if (provider.isMetaMask && !detectedWallets.includes('MetaMask')) detectedWallets.push('MetaMask');
            });
        }

        console.log('Detected wallets:', detectedWallets);

        // ✅ If multiple wallets detected, show error
        if (detectedWallets.length > 1) {
            alert("Multiple wallets detected, please disable wallets except metamask and refersh the page");
            return;
        }

        // ✅ If only one wallet but it's not MetaMask, show error
        if (detectedWallets.length === 1 && !detectedWallets.includes('MetaMask')) {
            alert("Multiple wallets detected, please disable wallets except metamask and Refersh the page");
            return;
        }

        // ✅ Find MetaMask provider
        let metaMaskProvider = null;

        if (window.ethereum.providers && Array.isArray(window.ethereum.providers)) {
            metaMaskProvider = window.ethereum.providers.find(provider => provider.isMetaMask);
        } else if (window.ethereum.isMetaMask) {
            metaMaskProvider = window.ethereum;
        }

        // ❌ If no MetaMask detected
        if (!metaMaskProvider) {
            alert("MetaMask not detected. Please install MetaMask and disable other wallets.");
            return;
        }

        try {
            // ✅ Use MetaMask provider directly
            const accounts = await metaMaskProvider.request({ method: "eth_requestAccounts" });

            // ✅ Check if MetaMask is unlocked
            if (typeof metaMaskProvider._metamask?.isUnlocked === "function") {
                const unlocked = await metaMaskProvider._metamask.isUnlocked();
                if (!unlocked) {
                    alert("Please unlock MetaMask.");
                    return;
                }
            }

            const web3 = new Web3(metaMaskProvider);
            console.log("✅ Connected to MetaMask:", accounts[0]);
            stkTokenContract = new web3.eth.Contract(CONTRACT_ABI, CONTRACT_ADDRESS);

            const chainId = await web3.eth.getChainId();
            if (chainId !== 97) {
                await switchToBNBTestnet();
                return; // Stop execution until user switches network
            }


            // ✅ Check if connected account is the contract owner
            try {
                const ownerAddress = await stkTokenContract.methods.owner().call();
                if (accounts[0].toLowerCase() !== ownerAddress.toLowerCase()) {
                    const shortAddress = `${ownerAddress.slice(0, 6)}...${ownerAddress.slice(-4)}`;
                    alert(`Wrong wallet connected! Please connect with owner wallet: ${shortAddress}`);
                    return;
                }
            } catch (ownerError) {
                console.error("Error fetching contract owner:", ownerError);
                // Continue without owner check if contract call fails
            }

            return accounts[0];
        } catch (error) {
            console.error("❌ MetaMask connection error:", error);
            if (error.code === 4001) {
                alert("MetaMask connection was rejected by user.");
            } else {
                alert("Failed to connect to MetaMask. Please try again.");
            }
        }
    };


    // const startPresale = async (round) => {
    //     try {
    //         const account = await connectWallet();

    //         if (!account) return;

    //         //            const chainId = await web3.eth.getChainId();
    //         //   if (chainId !== 56) {
    //         //     await switchToBNBTestnet();
    //         //   }

    //         const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
    //         // const senderAddress = accounts[0];

    //         const ownerAddress = await stkTokenContract.methods.owner().call();

    //         // ✅ Validate connected wallet with contract owner
    //         if (account.toLowerCase() !== ownerAddress.toLowerCase()) {
    //             const shortAddress = `${ownerAddress.slice(0, 6)}...${ownerAddress.slice(-4)}`;
    //             alert(`Please connect ${shortAddress} wallet address`);
    //             return;
    //         }

    //         // Validate round data
    //         if (!round._id || !round.startDate || !round.endDate || !round.priceinusd || !round.supply) {
    //             console.error("Invalid round data", round);
    //             alert("Missing round details!");
    //             return;
    //         }

    //         const totalRounds = await stkTokenContract.methods.totalRounds().call();
    //         const _roundId = parseInt(totalRounds) + 1;
    //         // const _startTime = Math.floor(new Date(round.startDate).getTime() / 1000); // UNIX timestamp
    //         // const _endTime = Math.floor(new Date(round.endDate).getTime() / 1000);
    //         const _startTime = round.startDateTimestamp
    //         const _endTime = round.endDateTimestamp
    //         const _tokenPriceUSDT = web3.utils.toWei(round.priceinusd.toString(), "ether"); // Assuming token price in ETH units
    //         const _cap = parseInt(round.supply, 10);


    //         console.log("Params:", {
    //             _roundId, _startTime, _endTime, _tokenPriceUSDT, _cap
    //         });
    //         // Example function call (adjust based on your smart contract)
    //         const tx = await stkTokenContract.methods.addRound(_roundId, _startTime, _endTime, _tokenPriceUSDT, _cap).send({
    //             from: account
    //         });

    //         console.log("Transaction Successful:", tx);
    //         await createPost({
    //             _id: round._id,
    //             roundNum: tx.events.RoundAdded.returnValues.roundId,
    //             transactionHash: tx.transactionHash // From blockchain response
    //         });

    //         // alert("Presale Started!");
    //     } catch (error) {
    //         console.error("Error starting presale:", error);
    //         alert("Transfer failed, Please check console");
    //     }
    // };


    const [presaleData, setPresaleData] = useState([])
    const history = useHistory();
    const presaleListData = usePresaleListDetailsQuery();
    const [createPost, responseInfo] = useActiveRoundlistMutation();
    const [activeEdit, responseActiveEditInfo] = useActiveEditPresaleInfoMutation();
    const [checkEdit, responseCheckEditInfo] = useCheckEditPresaleInfoMutation();

    console.log(presaleListData);

    useEffect(() => {
        setPresaleData(presaleListData?.data?.data)
    }, [presaleListData?.status === "fulfilled"])

    useEffect(() => {
        presaleListData.refetch()
    }, [])

    // const updateActiveRecord = async (e, id) => {
    //     // e.preventDefault();
    //     console.log("addPresale:", id);
    //     await createPost({ 
    //         "_id": id,
    //         "roundNum":"",
    //         "transactionHash":
    //     });
    // }

    useEffect(() => {
        if (responseInfo?.data?.status === "success") {
            toast(responseInfo?.data?.message)
            presaleListData.refetch()
            // setTimeout(() => (window.location.href = '/#/presale'), 2000);
            // setTimeout(() => history.push('/presale'), 2000);
        } else if (responseInfo?.error?.data?.status === "fail") {
            toast(responseInfo?.error?.data?.message)
        }
        else if (responseInfo?.status === "fulfilled") {
            toast(responseInfo?.data?.message)
        }

    }, [responseInfo])

    // const startPresaleAndEdit = async (round) => {
    //     try {
    //         const account = await connectWallet();
    //         if (!account) return;

    //         const ownerAddress = await stkTokenContract.methods.owner().call();

    //         // ✅ Validate connected wallet with contract owner
    //         if (account.toLowerCase() !== ownerAddress.toLowerCase()) {
    //             const shortAddress = `${ownerAddress.slice(0, 6)}...${ownerAddress.slice(-4)}`;
    //             alert(`Please connect ${shortAddress} wallet address`);
    //             return;
    //         }

    //         // Validate round data
    //         if (!round?.roundNum || !round?.startDateTimestamp || !round?.endDateTimestamp || !round?.priceinusd || !round?.supply) {
    //             console.error("Invalid round data", round);
    //             alert("Missing round details!");
    //             return;
    //         }

    //         // ✅ Fetch totalRounds and increment
    //         const _roundId = parseInt(round?.roundNum);

    //         // const _startTime = Math.floor(new Date(startDate).getTime() / 1000);
    //         // const _endTime = Math.floor(new Date(endDate).getTime() / 1000);
    //         const _startTime = round?.startDateTimestamp;
    //         const _endTime = round?.endDateTimestamp;
    //         const _tokenPriceUSDT = web3.utils.toWei(round?.priceinusd.toString(), "ether");
    //         const _isActive = true
    //         const _cap = parseInt(round?.supply, 10);
    //         // const _isActive = presaleData.status === "Open" ? true : false;

    //         console.log("EditParams:", { _roundId, _startTime, _endTime, _tokenPriceUSDT, _cap, _isActive });

    //         // ✅ Blockchain transaction
    //         const tx = await stkTokenContract.methods
    //             .editRound(_roundId, _startTime, _endTime, _tokenPriceUSDT, _isActive, _cap,)
    //             .send({ from: account });

    //         console.log("Transaction Successful:", tx);

    //         // ✅ Prepare API payload dynamically
    //         const newPost = {
    //             "_id": round._id,
    //             "presaleTitle": round.presaleTitle,
    //             "startDate": round.startDate,
    //             "endDate": round.endDate,
    //             "supply": round.supply,
    //             "priceinusd": Number(round.priceinusd),
    //             "salepercentage": round.salepercentage,
    //         };

    //         // ✅ Call checkEdit API with newPost
    //         const checkResponse = await checkEdit(newPost).unwrap();

    //         if (checkResponse?.status === "success") {
    //             await activeEdit({
    //                 ...round,
    //                 transactionHash: tx.transactionHash,
    //             });
    //             toast.success("Presale updated successfully!");
    //         } else {
    //             toast.error(checkResponse?.message || "Check failed after contract call!");
    //         }
    //         alert("Presale Updated successfully!");
    //     } catch (error) {
    //         console.error("Error starting presale:", error);
    //         alert("Transfer failed, Check console");
    //     }
    // };

    const handlePresale = async (round) => {
        try {
            const account = await connectWallet();
            if (!account) return;

            const ownerAddress = await stkTokenContract.methods.owner().call();

            // ✅ Validate connected wallet
            if (account.toLowerCase() !== ownerAddress.toLowerCase()) {
                const shortAddress = `${ownerAddress.slice(0, 6)}...${ownerAddress.slice(-4)}`;
                alert(`Please connect ${shortAddress} wallet address`);
                return;
            }

            // ✅ Validate round data
            if (!round?.startDateTimestamp || !round?.endDateTimestamp || !round?.priceinusd || !round?.supply) {
                console.error("Invalid round data", round);
                alert("Missing round details!");
                return;
            }

            let tx;
            let _roundId;
            const _startTime = round?.startDateTimestamp;
            const _endTime = round?.endDateTimestamp;
            const _tokenPriceUSDT = web3.utils.toWei(round?.priceinusd.toString(), "ether");
            // const _cap = parseInt(round?.supply, 10);
            const _cap = web3.utils.toWei(round?.supply.toString(), "ether");

            if (!round?.hash || round?.hash === "") {
                // 🚀 Add Round flow
                const totalRounds = await stkTokenContract.methods.totalRounds().call();
                _roundId = parseInt(totalRounds) + 1;

                console.log("AddParams:", { _roundId, _startTime, _endTime, _tokenPriceUSDT, _cap });

                tx = await stkTokenContract.methods
                    .addRound(_roundId, _startTime, _endTime, _tokenPriceUSDT)
                    .send({ from: account });

                console.log("Transaction Successful (Add):", tx);

                await createPost({
                    _id: round._id,
                    roundNum: tx.events.RoundAdded.returnValues.roundId,
                    transactionHash: tx.transactionHash
                });

            } else {
                // ✏️ Edit Round flow
                _roundId = parseInt(round?.roundNum);
                const _isActive = true;

                console.log("EditParams:", { _roundId, _startTime, _endTime, _tokenPriceUSDT, _cap, _isActive });

                tx = await stkTokenContract.methods
                    .editRound(_roundId, _startTime, _endTime, _tokenPriceUSDT, _isActive)
                    .send({ from: account });

                console.log("Transaction Successful (Edit):", tx);

                // ✅ Build payload for checkEdit
                const newPost = {
                    "_id": round._id,
                    "presaleTitle": round.presaleTitle,
                    "startDate": round.startDate,
                    "endDate": round.endDate,
                    "supply": round.supply,
                    "priceinusd": Number(round.priceinusd),
                    "salepercentage": round.salepercentage,
                };

                // ✅ First call checkEdit API
                const checkResponse = await checkEdit(newPost).unwrap();

                if (checkResponse?.status === "success") {
                    await activeEdit({
                        ...round,
                        transactionHash: tx.transactionHash,
                    });
                    // toast.success("Presale updated successfully!");
                } else {
                    toast.error(checkResponse?.message || "Check failed after contract call!");
                }
            }
        } catch (error) {
            console.error("Error in handlePresale:", error);
            // alert("Transfer failed, Check console");
        }
    };

    useEffect(() => {
        if (responseActiveEditInfo?.data?.status === "success") {
            toast(responseActiveEditInfo?.data?.message)
            // setTimeout(() => (window.location.href = '/#/presale'), 2000);
            setTimeout(() => history.push('/presale'), 2000);
        } else if (responseActiveEditInfo?.error?.data?.status === "fail") {
            toast(responseActiveEditInfo?.error?.data?.message)
        }
        else if (responseActiveEditInfo?.status === "fulfilled") {
            toast(responseActiveEditInfo?.data?.message)
        }

    }, [responseActiveEditInfo])

    return (
        <div>
            <Toaster
                toastOptions={{
                    style: {
                        fontSize: '14px',
                        padding: '10px 15px',
                        maxWidth: '300px',
                        lineHeight: '1.3',
                    },
                }}
            />
            <div class="content-wrapper">

                <section class="content-header">
                    <div class="container-fluid">

                        <div class="row mb-2">
                            <div class="col-sm-6">
                                {/* <h5>Add List</h5> */}
                            </div>
                            <div class="col-sm-6">
                                <ol class="breadcrumb float-sm-right text">
                                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                                    <li class="breadcrumb-item active">Presale Round List</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>


                <section class="content">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title"></h3>
                                        <div class="box-tools cards">
                                            <h3 style={{ fontSize: "19px" }}>Presale Round List</h3>
                                            <Link to="/add-presale">
                                                <button type="button" class="btn btn-primary pull-right addAdmin">
                                                    <i class="fa fa-plus"></i> &nbsp; Add Presale
                                                </button>
                                            </Link>

                                        </div>
                                    </div>


                                    <div class="card-body">
                                        <div class="table-responsive">
                                            <table id="example" class="table table-bordered table-striped table-hover" datatable
                                            >
                                                <thead>
                                                    <tr className='tr'>

                                                        <th>Presale Title</th>
                                                        {/* <th>Price (BNB)</th> */}
                                                        <th>Price (USDT)</th>
                                                        {/* <th>Max Amount</th> */}
                                                        {/* <th>Min Amountt</th> */}
                                                        <th>Status</th>
                                                        <th>StartDate</th>
                                                        <th>EndDate</th>
                                                        <th>Action</th>

                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {presaleData?.map(e => (
                                                        <tr className='tr'>

                                                            <td>{e.presaleTitle}</td>
                                                            {/* <td>{e.price}</td> */}
                                                            <td>{e.priceinusd}</td>
                                                            {/* <td>{e.maxAmount}</td>
                                                            <td>{e.minAmount}</td> */}
                                                            <td>{e.status == "notStarted" ? "Not Started" : e.status}</td>
                                                            <td>{e.startDate}</td>
                                                            <td>{e.endDate}</td>
                                                            <td>
                                                                <div
                                                                    className='d-flex justify-content-start text-center'>
                                                                    <span
                                                                        onClick={() => handlePresale(e)}
                                                                        style={{ fontSize: "large", cursor: "pointer", color: "#72afd2" }}
                                                                        title="Start Presale"
                                                                    >
                                                                        <i className="fas fa-rocket" style={{ marginRight: "8px" }}></i>
                                                                    </span>

                                                                    {/* {e.hash === "" ? (
                                                                        <div>
                                                                            <span
                                                                                onClick={() => startPresale(e)}
                                                                                // onClick={() => updateActiveRecord(null, e._id)}
                                                                                style={{ fontSize: "large", cursor: "pointer", color: "#72afd2" }}
                                                                                title="Start Presale"
                                                                            >
                                                                                <i className="fas fa-play" style={{ marginRight: "8px", }}></i>
                                                                            </span>
                                                                        </div>
                                                                    ) : (
                                                                        // <div style={{ width: "1.5em" }}></div>
                                                                        <div>
                                                                            <span
                                                                                onClick={() => startPresaleAndEdit(e)}
                                                                                style={{ fontSize: "large", cursor: "pointer", color: "#72afd2" }}
                                                                                title="Start Presale"
                                                                            >
                                                                                <i className="fas fa-play" style={{ marginRight: "8px", }}></i>
                                                                            </span>
                                                                        </div>
                                                                    )} */}

                                                                    {e.status && e.status.toLowerCase() !== 'closed' && (
                                                                        <Link to={`/edit-presale/${e._id}`}>
                                                                            <i className="fas fa-pen-square" style={{ fontSize: "large", marginRight: "7px" }}></i>
                                                                        </Link>
                                                                    )}

                                                                    <Link
                                                                        to={`/view-presale/${e._id}`}
                                                                    >
                                                                        <i class="fa fa-eye eye" style={{ fontSize: "large" }}></i>
                                                                    </Link>
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    ))}
                                                </tbody>


                                            </table>
                                        </div>
                                    </div>

                                </div>



                            </div>

                        </div>


                    </div>

                </section>
                <Footer></Footer>
            </div>
        </div>
    )
}

export default PresaleRoundList;